import {
  type ITrackingActions,
  TRACKING_ACTIONS,
  TRACKING_CATEGORIES,
  TRACKING_EVENTS,
} from '@cx-web/feature-tracking';

export const handleEvent = (label: string | undefined, trackingActions: ITrackingActions): void => {
  if (label) {
    trackingActions.eventTracking({
      event: TRACKING_EVENTS.BOTTOM_NAVIGATION,
      eventCategory: TRACKING_CATEGORIES.NAVIGATION,
      eventAction: TRACKING_ACTIONS[TRACKING_EVENTS.BOTTOM_NAVIGATION],
      eventLabel: label,
    });
  }
};
